import React from "react";

import Unical from "../imgs/logos/unical.svg";
import Unicross from "../imgs/logos/unicross.svg";
import Futo from "../imgs/logos/futo.svg";
import Udemy from "../imgs/logos/udemy.svg";
import SkillShare from "../imgs/logos/skillshare.svg";
import Telegram from "../imgs/logos/telegram.svg";

const Partner = () => {
  return (
    <div className="mt-20 md:mt-32">
      <div className="px-12">
        <p className="text-sm text-[#374D5D] text-center mb-5">
          Loved by learners across various platforms and institutions
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-2 md:px-8 flex justify-center items-center flex-wrap">
        <img src={Unical} className="h-14 w-20 mr-5 mb-3 md:mr-14" />
        <img src={Futo} className="h-14 w-14 mr-5 mb-3 md:mr-14" />
        <img src={Unicross} className="h-14 w-20 mr-5 mb-3 md:mr-14" />
        <img src={Udemy} className="h-14 w-16 mr-5 mb-3 md:mr-14" />
        <img src={SkillShare} className="h-14 w-12 mr-5 mb-3 md:mr-14" />
        <img src={Telegram} className="h-14 w-14 mb-3" />
      </div>
    </div>
  );
};

export default Partner;
